export default "__VITE_ASSET__c32e44c9__"